export const DEFAULT_PANEL_QUERY_PARAMS = {
  limit: 15,
  offset: 0,
} as const
